'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = require('redux');

var _reactRouterRedux = require('react-router-redux');

var _NotificationMiddleware = require('ReduxMessenger/middleware/NotificationMiddleware');

var _NotificationMiddleware2 = _interopRequireDefault(_NotificationMiddleware);

var _reduxThunk = require('redux-thunk');

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _usageTrackerRedux = require('usage-tracker-redux');

var _reducers = require('./reducers');

var _reducers2 = _interopRequireDefault(_reducers);

var _UsageTrackerContainer = require('./tracking/UsageTrackerContainer');

var _UsageTrackerContainer2 = _interopRequireDefault(_UsageTrackerContainer);

var _usageEventHandlers = require('./lib/usageEventHandlers');

var _usageEventHandlers2 = _interopRequireDefault(_usageEventHandlers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var devtools = window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : function (f) {
  return f;
};

var middleware = function middleware(history) {
  return [_NotificationMiddleware2.default, (0, _usageTrackerRedux.usageTrackerMiddleware)(_UsageTrackerContainer2.default.get(), _usageEventHandlers2.default), _reduxThunk2.default, (0, _reactRouterRedux.routerMiddleware)(history)];
};

exports.default = function (history) {
  return (0, _redux.createStore)(_reducers2.default, (0, _redux.compose)(_redux.applyMiddleware.apply(undefined, _toConsumableArray(middleware(history))), devtools));
};

module.exports = exports['default'];